import React from 'react';
import { useTranslation } from 'react-i18next';
import { IonButton } from '@ionic/react';
import { FarecardAutoload } from '../../services/types/apitypes';
import { currencyFormat } from '../../utils/currency';
import './CardAutoloadDetails.css';

type CardAutoloadDetailsProps = {
  autoload: FarecardAutoload;
  paymentinfo: string;
  toggle: (al: FarecardAutoload) => void;
  remove: (al: FarecardAutoload) => void;
  edit: (al: FarecardAutoload) => void;
};

export default function CardAutoloadDetails({
  autoload,
  paymentinfo,
  remove,
  edit,
  toggle,
}: CardAutoloadDetailsProps) {
    const { t, i18n } = useTranslation('global');

     function formatOrdinal(n: number, lang: string): string {
        if (lang === 'en') {
            const s = ["th", "st", "nd", "rd"];
            const v = n % 100;
            return `${n}${s[(v - 20) % 10] || s[v] || s[0]}`;
        }
        return `${n}.`;
    }

  return (
    <>
      <h1 className="h1 h1plus ion-text-center">{t('cardautoload.title')}</h1>
      <p className="pt-3 pb-5 instructions ion-text-center">
        {t('cardautoload.info')}
      </p>
      <p className="pt-3 ">
        <strong>
          {t('cardautoload.title')}:{' '}
          <span
            className={
              autoload.paused
                ? 'farecard-autoload-paused-color'
                : 'farecard-autoload-active-color'
            }
          >
            {t(autoload.paused ? 'cardautoload.paused' : 'cardautoload.active')}
          </span>
        </strong>
      </p>
      <div className="ion-text-center">
        <IonButton
          className="btn-default btn-wide-80 ion-text-center"
          onClick={() => toggle(autoload)}
        >
          {t(
            autoload.paused ? 'cardautoload.disabled' : 'cardautoload.enabled',
          )}
        </IonButton>
      </div>

      <div
        className={
          'farecard-autoload-text ' + (autoload.paused ? 'paused' : '')
        }
      >
          {autoload.dayOfMonthThreshold ? <p className="pt-3 pb-1">
                  {currencyFormat(autoload.autoloadAmount / 100)}
                  {t('cardautoload.detailsinfodate', {d: formatOrdinal(autoload.dayOfMonthThreshold, i18n.language.substring(0, 2))})}
          </p> :
        <p className="pt-3 pb-1">
          {currencyFormat(autoload.autoloadAmount / 100)}
          {t('cardautoload.detailsinfovalue')}
          {currencyFormat(autoload.balanceThreshold / 100)}
        </p>}

        <p className="pb-3">
          <b>{t('cardautoload.payment')}</b> <br />
          {paymentinfo}
        </p>
      </div>

      {!autoload.paused && (
        <>
          <div className="pt-5 pb-1 ion-text-center">
            <IonButton
              className="btn-default btn-wide-80"
              onClick={(e) => edit(autoload)}
            >
              {t('cardautoload.edit')}
            </IonButton>
          </div>
          <div className="ion-text-center">
            <IonButton
              fill="outline"
              className="btn-default btn-wide-80"
              onClick={(e) => remove(autoload)}
            >
              {t('cardautoload.delete')}
            </IonButton>
          </div>
        </>
      )}
    </>
  );
}
